// extracted by mini-css-extract-plugin
export default {"page":"style_page__KC1Bu","actions":"style_actions__yOsMq","card":"style_card__f+zm-","content":"style_content__oeKSi"};